let CuttingParameters = (function() {
  let C = function(r, ae, fz, ap, vc_eff) {
    this.r = r;
    this.ae = ae || 0;
    this.ap = ap || 0;
    this.fz = fz || 0;
    this.vc_eff = vc_eff || 0;
    this.Rz = 0;
    this.Ra = 0;
    this.vc = 0;
    this.r_eff = 0;
    this.r_Rz = 0;
    this.thetaH = 0;
    this.thetaReff = 0;
    this.phiF = 0;
    this.n = 0;
    this.computeRa();
  }

  C.calc = {
    fz: function (vf, z, n) {
      return vf / (n * z) || 0;
    },
    n_fz: function (fz, vf, z) {
      return vf / (z * fz) || 0;
    },
    vc_fz: function (fz, vf, z, d) {
      let n = this.n_fz(fz, vf, z) || 0;
      return this.vc(n, d) || 0;
    },
    vf_fz: function (fz, n, z) {
      return fz * z * n || 0;
    },
    fn_fz: function (fz, z) {
      return fz * z || 0;
    },
    fn: function (vf, n) {
      return vf / n || 0;
    },
    vf_fn: function (fn, n) {
      return fn * n || 0;
    },
    fz_fn: function (fn, z) {
      return fn / z || 0;
    },
    vc: function (n, d) {
      return n * Math.PI * d / (1000) || 0;
    },
    n: function (vc, d) {
      return vc * 1000 / (Math.PI * d) || 0;
    },
    ft: function (n, z) {
      return n / 60 * z || 0;
    },
    n_ft: function (ft, z) {
      return ft * 60 / z || 0;
    },
    P: function (ae, ap, vf) {
      return ae * ap * vf / (18000) || 0;
    },
    Q: function (ae, ap, vf) {
      return ae * ap * vf / 1000 || 0;
    },
    hm_ae: function (fz, ae, d) {
      return fz * Math.sqrt(ae / d) || 0;
    },
    hm_ap: function (fz, ap, d) {
      return fz * Math.sqrt(ap / d) || 0;
    },
    d_flat: function (d, r) {
      let f = d - 2*r;
      if (f < 0) f = 0;
      return f;
    },
    d_eff: function (d, r, ap) {
      if (!ap) return d;
      if (ap > r) return d;
      let f = d - 2*r;
      if (f < 0) f = 0;
      return f + 2 * Math.sqrt(ap * (2 * r - ap)) || 0;
    },
    vc_eff: function (vc, ap, d, r) {
      let d_eff = this.d_eff(d, r, ap);
      return vc * d_eff / d;
    },
    vc_vc_eff: function (vc_eff, ap, d, r) {
      let d_eff = this.d_eff(d, r, ap);
      return vc_eff * d / d_eff;
    }
  };

  C.prototype.update = function(ae, ap, fz) {
    this.ae = ae;
    this.ap = ap;
    this.fz = fz;
    this.computeReff();
    this.computeRz();
    this.computeRa();
    this.computeVC();
    this.computeN();
  }

  C.prototype.computeReff = function() {
    if(this.Rz === 0) {
      this.computeRz();
    }
    this.r_Rz = this.ae/2;
    if(this.ap > this.Rz) {
      this.r_eff = Math.sqrt(this.ap * (2 * this.r - this.ap));
    }
    else {
      this.r_eff = this.ae/2
    }
    this.thetaReff = Math.acos((this.r-this.ap)/this.r);
  }
  C.prototype.computeVC = function() {
    this.vc = this.vc_eff * this.r/this.r_eff;
  }
  C.prototype.computeN = function() {
    this.n = this.vc * 1000 / (2 * Math.PI * this.r);
  }
  C.prototype.computeRz = function() {
    if(this.r < this.ae/2) {
      this.Rz = this.r;
    } else {
      this.Rz = this.r - Math.sqrt(Math.pow(this.r, 2) - Math.pow(this.ae/2, 2));
    }
    this.computeAnglesRz();
  }
  C.prototype.computeAnglesRz = function() {
    this.thetaH = Math.acos((this.r-this.Rz)/this.r);
    this.phiH = Math.atan2((this.ae/2), this.r_eff);
  }
  C.prototype._computeRm = function(x) {
    let r = this.r;
    return r * x - 0.5*(Math.pow(r, 2) * Math.asin(x/r) + x*Math.sqrt( r*r - x*x ))
  }
  C.prototype.computeRm = function(x) {
    let r = this.r;
    return 1/x*this._computeRm(x);
  }
  C.prototype._computeRa = function(x) {
    let Rm = this.computeRm(x);
    let r = this.r;
    // let Ra = 0, Ran = 0;
    // let N = 200000;
    // let x0 = -x;
    // let x1 =  x;
    // let dx = (x1-x0) / (N-1);
    // let u = 0;
    // for(let i = 0; i < N; ++i) {
    //   u = i*dx + x0;
    //   Ran += Math.abs(r - Math.sqrt(r*r - u*u) - Rm);
    // }
    // Ran = Ran / N;

    let _this = this;
    let F = function(Rm, r, x) {
      let xs = Math.sqrt(Math.pow(r,2) - Math.pow(r-Rm,2));
      return _this._computeRm(0) - 2*_this._computeRm(xs) + _this._computeRm(x) + (2*xs - x)*Rm;
    }
    return 1/(x) * F(Rm, r, x);
  }
  C.prototype.computeRa = function() {
    this.computeReff();
    this.computeRz();
    this.computeAnglesRz();
    this.Ra = this._computeRa(this.ae/2);
  }
  C.prototype.computeAeFromRz = function() {
    this.ae = 2*Math.sqrt(Math.pow(this.r, 2) - Math.pow(this.r-this.Rz, 2));
  }
  C.prototype.computeAeFromRa = function() {
    let _this = this;
    let F = function(Ra, Rm, r, x) {
      let xs = Math.sqrt(Math.pow(r,2) - Math.pow(r-Rm,2));
      return (_this._computeRm(0) - 2*_this._computeRm(xs) + _this._computeRm(x) + 2*xs*Rm)/(Ra + Rm);
    }
    let n = 1e2;
    this.Rz = this.Ra * 2;
    this.computeAeFromRz();
    let Ra = 0, Rm = 0;
    let x = this.ae/2;
    let r = this.r;
    let dx = 1e-6;
    while(Math.abs(this.Ra - Ra)/this.Ra > 1e-6 && n--) {
      Rm = this._computeRm(x);
      // x = Math.min(this.maxAe()/2, F(this.Ra, Rm, this.r, x));
      let F = this.Ra - this._computeRa(x);
      let dF = (this._computeRa(x + dx) -  this._computeRa(x - dx)) / (2*dx);
      x = Math.min( this.maxAe()/2, Math.abs(x + F / dF) );
      if(isNaN(x)) x = this.maxAe() / 2;
      this.ae = x*2;
      Ra = this._computeRa(x);
    }
    this.computeRa();
  }

  C.prototype.maxAe = function() {
    return 2*this.r;
  }
  C.prototype.maxAp = function() {
    return this.r;
  }
  C.prototype.maxRz = function() {
    return this.r;
  }
  C.prototype.maxRa = function() {
    return 2/this.ae * ( this.computeRm(this.maxAe()/2) - this.computeRm(-this.maxAe()/2) );
  }

  C.prototype.relReff = function(cutter) {
    return cutter.R/this.r * this.r_eff;
  }
  C.prototype.relRRz = function(cutter) {
    return cutter.R/this.r * this.r_Rz;
  }
  C.prototype.relAe = function(cutter) {
    return cutter.R/this.r * this.ae;
  }
  C.prototype.relAp = function(cutter) {
    return cutter.R/this.r * this.ap;
  }
  C.prototype.relFz = function(cutter) {
    return cutter.R/this.r * this.fz;
  }
  C.prototype.relRz = function(cutter) {
    return cutter.R/this.r * this.Rz;
  }
  C.prototype.relF = function(cutter) {
    return cutter.R/this.r * this.f;
  }
  return C;
})();

export default CuttingParameters;
